import React, { useContext, useEffect } from "react";
import { Mui, PageHeadingContext } from "@osu/react-ui";
import { AppContext } from "../../App/context";

const LogOut = () => {
  const { handleSignOut, authStatus } = useContext(AppContext);
  const { setHeading } = useContext(PageHeadingContext);
  const isLoggedOut = (authStatus === "cleared");

  useEffect(() => {
    setHeading("Log Out");
  }, [setHeading]);

  useEffect(() => {
    let isMounted = true;
    if (!isMounted || isLoggedOut) {
      return;
    }

    const signOut = async () => {
      try {
        await handleSignOut();
      } catch (error) {
        console.error("error", error);
      }
    };

    signOut();
    return () => {
      isMounted = false;
    };
  }, [handleSignOut, isLoggedOut]);

  const alertSx = (theme) => ({ border: `solid 2px ${theme.palette.info.main}` });
  const alertTitleSx = (theme) => {
    const darkMode = (theme.palette.mode === "dark");
    const fn = (darkMode ? Mui.lighten : Mui.darken);
    return {
      color: fn(theme.palette.info.main, .5),
      fontWeight: theme.typography.fontWeightBold
    };
  };
  const message = (isLoggedOut ? "You are logged out." : "Logging out...");
  return (
    <Mui.Box>
      <Mui.Box>{message}</Mui.Box>
      {isLoggedOut &&
        <Mui.Alert className="margin-top-1" severity="info" sx={alertSx}>
          <Mui.AlertTitle sx={alertTitleSx}>Clear your browser on a shared machine!</Mui.AlertTitle>
          You MUST <Mui.Link href={"https://osuitsm.service-now.com/selfservice/kb_view.do?sys_kb_id=c591b3680a0a3c05014c37aec7538c29"}> clear your browsing history</Mui.Link> if
          this is a shared machine, or you risk improper access to any services to which you logged in recently. 
          Closing the browser will NOT prevent improper access in most cases!
        </Mui.Alert>
      }
    </Mui.Box>
  );
};

export default LogOut;
